























import { Component, Mixins, Prop } from 'vue-property-decorator'
import CoresDoPainel from './CoresDoPainel'
import { corDoTom } from '@/shareds/painel-do-cliente-shareds'
import type { BadgeDoCliente as BadgeParaExibir } from '@/shareds/painel-do-cliente-shareds'

@Component
export default class BadgeDoCliente extends Mixins(CoresDoPainel) {
	@Prop({ type: Object, required: true }) badge!: BadgeParaExibir

	get cor() {
		return this.corLegivel(corDoTom(this.badge.tom, this.corPrimaria))
	}
}
